import { BrowserContext2d } from "../browser";

export class FeishuContext2d extends BrowserContext2d {
    get globalAlpha() {
        return this._globalAlpha;
    }
    set globalAlpha(ga) {
        this.nativeContext.globalAlpha = ga * this.baseGlobalAlpha, this._globalAlpha = ga * this.baseGlobalAlpha;
    }
    getImageData(sx, sy, sw, sh) {
        return new Promise(((resolve, reject) => {
            var _a;
            try {
                tt.canvasGetImageData({
                    canvasId: null !== (_a = this.canvas.nativeCanvas.id) && void 0 !== _a ? _a : this.canvas.id,
                    x: sx,
                    y: sy,
                    width: sw,
                    height: sh,
                    success(res) {
                        resolve(res);
                    }
                });
            } catch (err) {
                reject(err);
            }
        }));
    }
    draw() {
        const _context = this.nativeContext;
        _context.draw && (this.drawPromise = new Promise((resolve => {
            _context.draw(!0, (() => {
                this.drawPromise = null, resolve(null);
            }));
        })));
    }
    createPattern(image, repetition) {
        return null;
    }
}

FeishuContext2d.env = "feishu";
//# sourceMappingURL=context.js.map
